import React, { useState } from "react";
import SvgIconElementUI from '../../../../../stories/components/cars/ResultsPage/RydeAssuredBanner/SvgIconElement/SvgIconElementUI';
import { goCashImage } from "../../../../../shared/config/constants"
import * as S from "./GoCashCompStyle";

const GoCashComp = ({ totalbalance, eligibleBalance, info, margin, apply_gocash=false, applyGocashAction }) => {
  return (
    <S.GoCashComp margin={margin}>
      <S.GoCashHeader>
     <S.GoCashTitle>
        <S.GoCashIcon src={goCashImage} />
        <span>goCash</span>
     </S.GoCashTitle>
        <S.GoCashToogleWrap>
        {apply_gocash ? (
             <span className="onText">₹{eligibleBalance} Applied</span>
            ) : (
             <span className="offText">Apply ₹{eligibleBalance}</span>
            )}
        <S.ToggleBtn>
          <S.ToggleStatus
            className={!apply_gocash ? "buttonOff" : "buttonOn"}
            onClick={applyGocashAction}
          >
            {!apply_gocash ? (
            <span className="off"> </span>
            ) : (
            <div className="on"><SvgIconElementUI iconName="GoCashWhiteTick" iconWidth="10px" iconHeight="4px" /></div>
            )
            }
          </S.ToggleStatus>
        </S.ToggleBtn>
        </S.GoCashToogleWrap>
      </S.GoCashHeader>
      <S.GoCashDetails>
        {totalbalance && <p className="balance">Total goCash Balance: ₹{totalbalance}</p>}
        {info && <p>{info}</p>}
      </S.GoCashDetails>
    </S.GoCashComp>
  );
};

export default GoCashComp;
